(() => {
  const bindCarousels = () => {
    document.querySelectorAll('[data-nqc-carousel]:not([data-nqc-bound])').forEach((track) => {
      track.setAttribute('data-nqc-bound', '1');
      const card = track.closest('.nqc-card');
      const dots = card ? [...card.querySelectorAll('.nqc-card__dot')] : [];
      const sync = () => {
        const w = track.clientWidth || 1;
        const i = Math.round(track.scrollLeft / w);
        dots.forEach((d, idx) => d.classList.toggle('nqc-card__dot--on', idx === i));
      };
      track.addEventListener('scroll', sync, { passive: true });
    });
  };

  const bindSwatches = () => {
    document.querySelectorAll('[data-nqc-sw]').forEach((row) => {
      row.addEventListener('click', (e) => {
        const sw = e.target.closest('.nqc-card__sw');
        if (!sw) return;
        e.preventDefault();
        row.querySelectorAll('.nqc-card__sw').forEach((s) => s.classList.remove('is-on'));
        sw.classList.add('is-on');
        const name = row.querySelector('[data-nqc-sw-name]');
        if (name) name.textContent = sw.getAttribute('data-sw-name') || '';
        const img = sw.getAttribute('data-sw-img');
        if (img) {
          const first = row.closest('.nqc-card')?.querySelector('.nqc-card__img');
          if (first) first.src = img;
        }
      });
    });
  };

  const init = () => {
    bindCarousels();
    bindSwatches();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
